module.exports = __webpack_public_path__ + "static/img/sound1.f8ca2c2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sound1.gif
// module id = g9xc
// module chunks = 110